"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryTable = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const table_field_1 = require("../../components/table-field/table-field");
const lodash_1 = require("lodash");
const history_api_1 = require("./history-api");
const table_field_cells_1 = require("../../components/table-field/table-field-cells");
const detail_context_1 = require("../detail/detail-context");
function HistoryTable({ id }) {
    const intl = react_intl_1.useIntl();
    const source = history_api_1.useHistorySource(id);
    const { addRefreshListener, removeRefreshListener } = react_1.useContext(detail_context_1.DetailContext);
    react_1.useEffect(() => {
        addRefreshListener(source.reset);
        return () => {
            removeRefreshListener(source.reset);
        };
    });
    const columns = [
        {
            name: intl.formatMessage({
                id: 'EAS_HISTORY_COLUMN_CREATED',
                defaultMessage: 'Datum',
            }),
            datakey: 'created',
            CellComponent: table_field_cells_1.TableFieldCells.DateTimeCell,
            width: 150,
        },
        {
            name: intl.formatMessage({
                id: 'EAS_HISTORY_COLUMN_OPERATION',
                defaultMessage: 'Typ změny',
            }),
            datakey: 'operation.name',
            width: 200,
        },
        {
            name: intl.formatMessage({
                id: 'EAS_HISTORY_COLUMN_CREATED_BY',
                defaultMessage: 'Autor změny',
            }),
            datakey: 'createdBy.name',
            width: 200,
        },
        {
            name: intl.formatMessage({
                id: 'EAS_HISTORY_COLUMN_DESCRIPTION',
                defaultMessage: 'Poznámka',
            }),
            datakey: 'description',
            width: 300,
        },
    ];
    return (react_1.default.createElement(table_field_1.TableField, { maxRows: 8, showRadioCond: () => false, showDetailBtnCond: () => false, showToolbar: false, value: source.items, columns: columns, onChange: lodash_1.noop, disabled: true }));
}
exports.HistoryTable = HistoryTable;
//# sourceMappingURL=history.js.map